import { adminFetch } from './dataProvider';

export interface LeadExportRow {
  captureDate: string;
  captureTime: string;
  personName: string;
  title: string;
  company: string;
  email: string;
  phone: string;
  linkedinUrl: string;
  captureMethodLabel: string;
  statusLabel: string;
  temperatureLabel: string;
  conferenceName: string;
  capturedByName: string;
  aiSummary: string;
  topOpportunityUsd: string;
  topOpportunityStage: string;
  openTaskCount: number;
  notesCount: number;
}

interface ExportPage {
  rows: LeadExportRow[];
  nextCursor: string | null;
}

export const CSV_EXPORT_CAP = 5_000;

export async function fetchLeadsExport(filter: {
  conferenceId?: string;
  repOid?: string;
  cursor?: string;
  limit?: number;
}): Promise<ExportPage> {
  const q = new URLSearchParams();
  if (filter.conferenceId) q.set('conferenceId', filter.conferenceId);
  if (filter.repOid)       q.set('repOid', filter.repOid);
  if (filter.cursor)       q.set('cursor', filter.cursor);
  q.set('limit', String(filter.limit ?? 1000));
  return adminFetch<ExportPage>(`/v1/admin/leads/export?${q.toString()}`);
}

/** Pulls every page up to CSV_EXPORT_CAP. Sets `reachedCap` if truncated. */
export async function fetchAllForExport(filter: {
  conferenceId?: string;
  repOid?: string;
}): Promise<{ rows: LeadExportRow[]; reachedCap: boolean }> {
  const rows: LeadExportRow[] = [];
  let cursor: string | undefined = undefined;
  do {
    const page: ExportPage = await fetchLeadsExport({ ...filter, cursor, limit: 1000 });
    rows.push(...page.rows);
    if (rows.length >= CSV_EXPORT_CAP) {
      return { rows: rows.slice(0, CSV_EXPORT_CAP), reachedCap: true };
    }
    cursor = page.nextCursor ?? undefined;
  } while (cursor);
  return { rows, reachedCap: false };
}
